import * as React from 'react';

import { type CrehanaTFunction, useTranslation } from '@crehana/i18n';
import Checkbox from '@crehana/ui/dist/Checkbox';

// TODO add type

export const rulesForRHFControllerComponent = (t: CrehanaTFunction) => ({
  required: {
    value: true,
    message: t('AUTH_VALIDATION_LEGALS_REQUIRED', {
      defaultValue:
        'Debes aceptar los Términos, Condiciones y Políticas para continuar.',
    }),
  },
});

export const LegalErrorMessage: React.FC<
  React.PropsWithChildren<{ message: string }>
> = ({ message }) => (
  <span className="font-legals text-red-main block mt-4" role="alert">
    {message}
  </span>
);

type LegalCheckboxProps = {
  onChange(value: any): void;
  value?: boolean;
  darkMode?: boolean;
  dataTestId?: string;
};

const LegalCheckbox: React.FC<React.PropsWithChildren<LegalCheckboxProps>> = ({
  onChange,
  value,
  darkMode,
  dataTestId,
}) => {
  const { t } = useTranslation();

  return (
    <Checkbox
      small
      darkMode={darkMode}
      data-testid={dataTestId}
      label={
        <React.Fragment>
          <span className={darkMode ? 'text-white' : ''}>
            {t('LEGALS_TEXT_1', {
              defaultValue: 'Acepto los ',
            })}
          </span>
          <a
            href="/legal/"
            target="_blank"
            className="font-legals text-gray-dark"
            style={{
              textDecoration: 'none',
            }}
          >
            {t('LEGALS_TEXT_2', {
              defaultValue: 'Términos, Condiciones y Políticas de Crehana.',
            })}
          </a>
        </React.Fragment>
      }
      onChange={event => {
        const { checked } = event.target;

        onChange(!checked);
      }}
      checked={value}
    />
  );
};

export default LegalCheckbox;
